// Un boleto por persona. Cada uno tiene su propio QR y su etiqueta (Adulto 1, Menor 2…) para que el guía
// sepa quién falta. Lógica pura: la usan la base de datos (lib/reservas.ts) y la vista previa (panel/operacion.ts).

export type Lugar = { adultos: number; ninos: number; etiqueta: string };

/** Una fila por persona, en el orden en que se muestran: primero adultos, luego menores. */
export function lugaresDelGrupo(adultos: number, ninos: number): Lugar[] {
  return [
    ...Array.from({ length: adultos }, (_, i) => ({ adultos: 1, ninos: 0, etiqueta: `Adulto ${i + 1}` })),
    ...Array.from({ length: ninos }, (_, i) => ({ adultos: 0, ninos: 1, etiqueta: `Menor ${i + 1}` })),
  ];
}

export type PersonaGrupo = { etiqueta: string; abordado: boolean; cancelado: boolean };
export type ProgresoGrupo = { aBordo: number; total: number; faltan: string[] };

/** Cuántos del grupo ya subieron y quiénes faltan. Los cancelados no cuentan. */
export function progresoDeGrupo(personas: PersonaGrupo[]): ProgresoGrupo {
  const vigentes = personas.filter((p) => !p.cancelado);
  return {
    aBordo: vigentes.filter((p) => p.abordado).length,
    total: vigentes.length,
    faltan: vigentes.filter((p) => !p.abordado).map((p) => p.etiqueta),
  };
}

/** Texto corto para el guía: "2 de 4 a bordo · faltan: Adulto 3, Menor 1". */
export function textoProgreso(p: ProgresoGrupo): string {
  const cabeza = `${p.aBordo} de ${p.total} a bordo`;
  return p.faltan.length ? `${cabeza} · faltan: ${p.faltan.join(", ")}` : `${cabeza} · completo`;
}
